document.addEventListener('DOMContentLoaded', () => {
    const stepSelections = {}; // tracks how many items added per step
    const productSelections = {}; // tracks if a product is already added

    const steps = document.querySelectorAll('.bundle-step');
    steps.forEach(step => stepSelections[step.dataset.step] = 0);

    const bundleAddToCart = document.querySelector('.bundle-add-to-cart'); // sticky button

    document.querySelectorAll('.bundle-product').forEach(card => {
        const step = card.dataset.step;
        const addBtn = card.querySelector('.add-box');
        const form = document.querySelector('form.product-bundle-forms');

        const stepEl = document.querySelector(`.bundle-step[data-step="${step}"]`);
        const stepLimit = parseInt(stepEl.dataset.limit);

        const productId = card.dataset.id;
        productSelections[productId] = 0;

        // ADD PRODUCT (only once per product)
        addBtn.addEventListener('click', () => {
            if (productSelections[productId] >= 1) return; // same product only once
            if (stepSelections[step] >= stepLimit) return; // respect step limit

            productSelections[productId] = 1;
            stepSelections[step] += 1;

            // Disable button and update text
            addBtn.classList.add('disabled');
            addBtn.innerText = 'Added';

            updateBundleProperties(form, card, 1);
            checkButtons(step);
            checkStickyAddToCart();
            //updateGiftWrap();
        });
    });

    // Remove product
    document.addEventListener('click', e => {
        const removeBtn = e.target.closest('.bundle-remove');
        if (!removeBtn) return;

        const stickyItem = removeBtn.closest('[data-bundle-id]');
        if (!stickyItem) return;

        const bundleId = stickyItem.dataset.bundleId;
        const product = document.querySelector(`.bundle-product[data-id="${bundleId}"]`);
        if (!product) return;

        const step = product.dataset.step;
        const addBtn = product.querySelector('.add-box');
        const form = document.querySelector('form.product-bundle-forms');

        // Reset product selection
        if (productSelections[bundleId] === 1) {
            productSelections[bundleId] = 0;
            stepSelections[step] -= 1;
        }

        // Reset button
        addBtn.classList.remove('disabled');
        addBtn.innerText = 'Add to Box';

        updateBundleProperties(form, product, 0);
        stickyItem.remove();

        checkButtons(step);
        checkStickyAddToCart();
        //updateGiftWrap(); 
    });

    function checkButtons(step) {
        const stepEl = document.querySelector(`.bundle-step[data-step="${step}"]`);
        const stepLimit = parseInt(stepEl.dataset.limit);
        const currentStepCount = stepSelections[step];

        document.querySelectorAll(`.bundle-product[data-step="${step}"] .add-box`).forEach(btn => {
            const productId = btn.closest('.bundle-product').dataset.id;
            const disabled = productSelections[productId] >= 1 || currentStepCount >= stepLimit;
            btn.classList.toggle('disabled', disabled);
            if (!disabled) btn.innerText = 'Add to Box';
        });
    }

    function checkStickyAddToCart() {
        const bundleAddToCart = document.getElementById('bundle-add-to-cart');
        const buttonMain = document.querySelector('.bundle-add-to-cart');
        const bundle_sticky = document.getElementById('bundle-sticky');
        if (!bundleAddToCart) return;

        let allStepsFilled = true; // assume all steps are filled
        let anyProductAdded = false; // for display logic

        // Loop through each step
        document.querySelectorAll('.bundle-step').forEach(step => {
            if (!step.classList.contains('last-step')) {
                const stepNum = step.dataset.step;
                const stepLimit = parseInt(step.dataset.limit);
                const count = stepSelections[stepNum] || 0;

                if (count < stepLimit) allStepsFilled = false; // step not fully filled
                if (count > 0) anyProductAdded = true; // at least one product added
            }
        });

        if (anyProductAdded) {
            // Show sticky button if at least one product added
            bundleAddToCart.style.display = 'flex';

            // Enable ONLY if all steps reached their limits
            if (allStepsFilled) {
                buttonMain.disabled = false;
                buttonMain.classList.remove('disabled');
            } else {
                buttonMain.disabled = true;
                buttonMain.classList.add('disabled');
            }

            console.log("bundle_sticky-->", bundle_sticky)
            bundle_sticky.classList.remove('disabled');
        } else {
            // Hide sticky button if nothing added
            bundleAddToCart.style.display = 'none';
            bundleAddToCart.disabled = true;
            bundleAddToCart.classList.add('disabled');

            console.log("bundle_sticky-->", bundle_sticky)
            bundle_sticky.classList.add('disabled');
        }
    }

    function updateBundleProperties(form, product, quantity) {
        if (!form || !product) return;

        const input = form.querySelector(`input[data-bundle-id="${product.dataset.id}"]`);

        if (quantity > 0) {
            if (!input) {
                const newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = `properties[Item${form.querySelectorAll('input[name^="properties[Item"]').length + 1}]`;
                newInput.dataset.bundleId = product.dataset.id;
                newInput.value = `${product.dataset.title}__${product.dataset.price}[sku:${product.dataset.sku}] x ${quantity}`;
                form.appendChild(newInput);

                const newInput1 = document.createElement('input');
                newInput1.type = 'hidden';
                newInput1.name = `properties[_Item_price${form.querySelectorAll('input[name^="properties[_Item_price"]').length + 1}]`;
                newInput1.dataset.bundleId = product.dataset.id;
                newInput1.value = `${product.dataset.price}`;
                form.appendChild(newInput1);
            } else {
                input.value = `${product.dataset.title}[sku:${product.dataset.sku}] x ${quantity}`;
            }
        } else {
            if (input) input.remove();
        }

        syncStickyItem(product, quantity);
    }

    function syncStickyItem(product, quantity) {
        const stickyWrap = document.querySelector('.sticky-products');
        if (!stickyWrap || !product) return;

        const bundleId = product.dataset.id;
        let item = stickyWrap.querySelector(`.sticky-item[data-bundle-id="${bundleId}"]`);

        if (quantity <= 0) {
            if (item) item.remove();
            return;
        }

        if (!item) {
            item = document.createElement('div');
            item.className = 'sticky-item';
            item.dataset.bundleId = bundleId;
            item.innerHTML = `
                <img src="${product.dataset.image}" alt="">
                <button type="button" class="bundle-remove">✕</button>
            `;
            stickyWrap.appendChild(item);
        }
    }

    document.addEventListener('submit', function (e) {
        const formbundle = e.target.closest('.product-bundle-forms');
        if (!formbundle) return;

        // Wait for Shopify to finish adding to cart
        setTimeout(() => {
            resetBundleSelection();
        }, 2000);
    });

    function resetStickyProducts() {
        if(document.querySelector('.sticky-item')!=null){
            document.querySelectorAll('.sticky-products .sticky-item').forEach(item => item.remove());
        }
    }

    function resetBundleSelection() {
        // 1️⃣ Reset step selection counters
        Object.keys(stepSelections).forEach(step => {
            stepSelections[step] = 0;
        });

        // 2️⃣ Reset per-product selection
        Object.keys(productSelections).forEach(productId => {
            productSelections[productId] = 0;
        });

        // 3️⃣ Reset all product buttons and UI
        document.querySelectorAll('.bundle-product').forEach(product => {
            const addBox = product.querySelector('.add-box');
            const qtyBox = product.querySelector('.qty-box');
            const qtyVal = product.querySelector('.qty-value');

            if (addBox) {
                addBox.classList.remove('disabled');
                addBox.innerText = 'Add to Box'; // reset text
            }

            if (qtyBox) {
                qtyBox.classList.add('hidden');
            }

            if (qtyVal) {
                qtyVal.innerText = '1';
            }
        });

        // 4️⃣ Reset steps (first active, last visible)
        const steps = document.querySelectorAll('.bundle-step');
        steps.forEach((step, index) => {
            step.classList.remove('active', 'completed');

            if (index === 0) {
                step.classList.add('active');
                step.style.display = 'block';
            } else if (step.classList.contains('last-step')) {
                step.style.display = 'block';
            } else {
                step.style.display = 'none';
            }
        });

        // 5️⃣ Reset step indicators
        document.querySelectorAll('.bundle-step-indicator').forEach((ind, index) => {
            ind.classList.remove('active', 'completed');
            if (index === 0) ind.classList.add('active');
        });

        // 6️⃣ Clear sticky selected products
        resetStickyProducts();

        // 7️⃣ Remove bundle properties from form
        const form = document.querySelector('.product-bundle-forms');
        if (form) {
            form.querySelectorAll('input[name^="properties[Item"]').forEach(i => i.remove());
            form.querySelectorAll('input[name^="properties[_Item_price"]').forEach(i => i.remove());
        }

        // 8️⃣ Reset sticky Add-to-Cart
        const addBtnReset = document.getElementById('bundle-add-to-cart');
        if (addBtnReset) {
            addBtnReset.disabled = true;
            addBtnReset.style.display = 'none';
            addBtnReset.classList.add('disabled');
        }
    }

    function updateGiftWrap() {
        const giftDiv = document.querySelector('.giftwrap-box-product');
        if (!giftDiv) return;

        const giftWrapId = 'giftwrap-' + giftDiv.dataset.productId;
        const stickyWrap = document.querySelector('.sticky-products');
        const form = document.querySelector('.product-bundle-forms');
        if (!stickyWrap || !form) return;

        // Check if all steps are filled
        let allStepsFilled = true;
        document.querySelectorAll('.bundle-step').forEach(step => {
            if (!step.classList.contains('last-step')) {
                const stepNum = step.dataset.step;
                const stepLimit = parseInt(step.dataset.limit);
                const count = stepSelections[stepNum] || 0;
                if (count < stepLimit) allStepsFilled = false;
            }
        });

        // Check if gift wrap sticky item exists
        let existingGift = stickyWrap.querySelector(`.sticky-item[data-bundle-id="${giftWrapId}"]`);
        let existingInput = form.querySelector(`input[data-bundle-id="${giftWrapId}"]`);

        if (allStepsFilled) {
            // ✅ Add sticky item if not exists
            if (!existingGift) {

                const existingGift = document.createElement('div');
                existingGift.className = 'sticky-item giftwrap-item';
                existingGift.dataset.bundleId = giftWrapId;

                // wrapper div
                const giftContent = document.createElement('div');
                giftContent.className = 'gift-content';

                // image
                const img = document.createElement('img');
                img.src = giftDiv.dataset.productImg;
                img.alt = 'Gift Wrap';

                // free text
                const freeSpan = document.createElement('span');
                freeSpan.textContent = 'free';

                // plus div
                const plusDiv = document.createElement('div');
                plusDiv.className = 'gift-plus';
                plusDiv.textContent = '+';

                // append
                giftContent.appendChild(img);
                giftContent.appendChild(freeSpan);

                existingGift.appendChild(giftContent);
                existingGift.appendChild(plusDiv);

                stickyWrap.appendChild(existingGift);

            }

            // ✅ Add hidden property input if not exists
            if (!existingInput) {
                existingInput = document.createElement('input');
                existingInput.type = 'hidden';
                existingInput.name = `properties[Item${form.querySelectorAll('input[name^="properties[Item"]').length + 1}]`;
                existingInput.dataset.bundleId = giftWrapId;
                existingInput.value = `Gift Box x 1`;
                form.appendChild(existingInput);

                existingInput = document.createElement('input');
                existingInput.type = 'hidden';
                existingInput.name = `properties[_Item_price${form.querySelectorAll('input[name^="properties[_Item_price"]').length + 1}]`;
                existingInput.dataset.bundleId = giftWrapId;
                existingInput.value = `10000`;
                form.appendChild(existingInput);
            }
        } else {
            // Remove gift wrap if bundle is incomplete
            if (existingGift) existingGift.remove();
            if (existingInput) existingInput.remove();
        }
    }

});
